/** OpenAI LLM adapter — STUB. Implements LLMPort. */
export function createOpenAILLM() {
  return {
    async status() { return { vendor: "openai", model: "gpt-5.2", status: "not_configured" }; },
    async generatePlay() { throw new Error("OPENAI_LLM_NOT_IMPLEMENTED"); },
    async regeneratePlay() { throw new Error("OPENAI_LLM_NOT_IMPLEMENTED"); },
  };
}
